import * as React from "react"
import { NavLink } from "react-router-dom"
import { SimpelPage } from "../../../../utils"
import { WordPress } from "../../../wordpress/wordpress_api"
import { loader } from "../loader.mod"
import { Pagination } from "../pagination.mod"
import { ArticlesOverviewState } from "./ArticlesOverview.widget"

interface Prosp {
    articles: SimpelPage<WordPress.PostTypeResponse>
    isLoading: boolean
    onPropChange: <K extends keyof ArticlesOverviewState>(key: K, value: ArticlesOverviewState[K]) => void
}

export const ArticlesOverviewLayout = (props: Prosp) => {
  return <section className="block block--listing lst">
    <div className="lst__inner container container--s gutter--m spacing--m">
      {!props.isLoading && props.articles.items.length > 0 && (
        <ul className="lst__list">
          {props.articles.items.map(art => <li className="lst__item">
            <NavLink className="lst__link" to={`/article/${art.slug}`}>
              <h3 className="lst__title ff--primary typo--ml">{art.title.rendered}</h3>
            </NavLink>
          </li>)}
        </ul>)}
      {props.isLoading && loader.run(undefined)}
      {!props.isLoading && props.articles.items.length == 0 && <h3 className="lst__title ff--primary typo--ml">Geen resultaten</h3>}
      {!props.isLoading && props.articles.total_pages > 1 && (
        <Pagination
          pager={{
            current_page: props.articles.current_page,
            items_per_page: props.articles.page_size,
            total_items: props.articles.total_items,
            total_pages: props.articles.total_pages,
          }}
          setPage={(page) => props.onPropChange("current_page", page)}
        />
      )}
    </div>
  </section>
}